import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {ReservationService} from '@app/_components/reservation';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';
import { InboxMailSMsComponent } from '@app/_components/inbox/inbox-mail-sms/inbox-mail-sms.component';
import { InboxListVerticalComponent } from '@app/_components/inbox/inbox-list-vertical/inbox-list-vertical.component';
  import { VehicleBookingService } from '@app/_components/vehicle-booking/vehicle-booking.service';
import { AccessCodeService } from '@app/_components/access-code';

@Component({
    selector: 'app-report-reservation',
    templateUrl: './report-reservation.component.html',
    styleUrls: ['./report-reservation.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ReportReservationComponent implements OnInit, OnChanges {
  @Input() reservation: any;
  @Input() isPrintMode: boolean = false;
	  constructor(
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
    private reservationService: ReservationService,
    private dialog: MatDialog,
    private vehicleBookingService: VehicleBookingService,
    private accessCodeService:AccessCodeService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		// 	this.showFilter = data?.showFilter;
		// this.showPagination = data?.showPagination;
  }
  
  notesChatConfig: NotesChatConfig;
  vehicles: any[] = [];
  lockLocations: any[] = [];
  
  private baseConfig: NotesChatConfig = {
    title: '',
    maxWidth: '100%',
    maxHeight: '100%',
    customClass: '',
    fieldsPosition: 'top',
    showFilters: true,
    showHeader: false,
    showSortOptions: false,
    fillParent: false,
    sortByDate: 'desc',
    allowEdit: true,
    allowDelete: false,
    allowAdd: true,
    emptyNotesText: 'No notes added',
    placeholder: 'Enter remarks',
    theme: 'default',
    maxNoteLength: 111111,
    editButtonText: 'Edit Note',
    deleteButtonText: 'Delete Note',
    cancelButtonText: 'Cancel',
    showUserFilters: true,
    noteTypes: [
      { value: 1, name: 'General', color: '#DCDCDC' },
      { value: 2, name: 'Action Item', color: '#ffcccc' },
      { value: 4, name: 'Meeting Notes', color: '#ade061' },
      { value: 5, name: 'Status Update', color: '#FFFF99' },
      { value: 6, name: 'Arrival', color: '#0066FF' },
      { value: 7, name: 'Departure', color: '#9333EA' }
    ],
    statusOptions: [
      { value: 0, name: 'Open', color: '#D3D3D3' },
      { value: 1, name: 'Complete', color: '#90EE90' },
      { value: 2, name: 'Proposed', color: '#FFE599' },
      { value: 3, name: 'On Hold', color: '#ADD8E6' },
      { value: 4, name: 'Cancelled', color: '#F4A6A6' },
      { value: 5, name: 'In Progress', color: '#FFA500' }
    ],
    highlightTypes: [
      { name: 'Arrival', color: '#0066FF' },
      { name: 'Departure', color: '#9333EA' }
    ]
  };

	ngOnInit(): void {
    this.updateNotesChatConfig();
    this.vehicles = this.vehicleBookingService.vehicles;
    this.lockLocations = this.accessCodeService.lockLocations;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isPrintMode']) {
      this.updateNotesChatConfig();
    }
  }

 

  private updateNotesChatConfig(): void {
    // When in print mode, disable add/edit/delete
    // Create a new object reference to trigger change detection
    this.notesChatConfig = {
      ...this.baseConfig,
      allowEdit: !this.isPrintMode,
      allowDelete: false,
      allowAdd: !this.isPrintMode,
      showUserFilters: !this.isPrintMode
    };
  }

  getStatus(reservation: any){
    if (reservation?.reservationStatus) {
      const status = this.reservationService.reservationStatuses.find((e: any) => e.value == reservation.reservationStatus);
      return status.name;
    }
    else {
      return '';
    }
  }

  isMaintainance(reservation: any) {
    return reservation.reservationStatus === 'NA';
  }

  isCheckoutReservation(reservation: any) {
      return reservation?.reservationType === 'OUT';
  }


  openEmailDialog(res: any): void {
    if (!res?.emailAddress) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';

    const resForDialog = { ...res, guestProfile: { emailAddress: res.emailAddress } };
    dialogConfig.data = {
      title: 'New Email',
      msgTopic: [100],
      mobilePhone: res?.primaryMobilePhone || res?.mobilePhone,
      msgTopicId: [res?.reservationId],
      reservations: [resForDialog],
      sendViaEmail: true,
      sendViaSms: false
    };

    const dialogRef = this.dialog.open(InboxMailSMsComponent, dialogConfig);
    if (dialogRef.componentInstance) {
      dialogRef.componentInstance.doAdd.subscribe(() => dialogRef.close());
      dialogRef.componentInstance.doUpdate.subscribe(() => dialogRef.close());
    }
  }

  getVehicleName(vehiclePref: any) {
    if(vehiclePref){
      return this.vehicles.find((e: any) => e.value == vehiclePref)?.name || vehiclePref;
    }
    return '';
  }
  openSmsDialog(res: any, phone: string | null | undefined): void {
    if (!phone || phone === 'null') return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';

    const resForDialog = { ...res, guestProfile: { emailAddress: res?.emailAddress } };


    dialogConfig.data = {
      title: 'New SMS',
      msgTopic: [100],
      msgTopicId: [res?.reservationId],
      mobilePhone: phone,
      reservations: [resForDialog],
      sendViaEmail: false,
      sendViaSms: true
    };

    const dialogRef = this.dialog.open(InboxMailSMsComponent, dialogConfig);
    if (dialogRef.componentInstance) {
      dialogRef.componentInstance.doAdd.subscribe(() => dialogRef.close());
      dialogRef.componentInstance.doUpdate.subscribe(() => dialogRef.close());
    }
  }

  getLockLocationName(accessCode: any) {
		if (accessCode?.lockLocation) {
			const lockLocation = this.lockLocations.find((e: any) => e.value == accessCode.lockLocation);
			return lockLocation.name;
		}
		else {
			return '';
		}
	}

  openInboxDialog(res: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    dialogConfig.data = {};

    const dialogRef = this.dialog.open(InboxListVerticalComponent, dialogConfig);
    dialogRef.componentInstance.msgTopic = 100;
    dialogRef.componentInstance.msgTopicId = res?.reservationId;
    dialogRef.componentInstance.orderId = res?.orderId;
    dialogRef.componentInstance.templateMsgAudience = 100;
    dialogRef.componentInstance.reservations = [res];
    dialogRef.componentInstance.mobilePhone = res?.primaryMobilePhone || res?.mobilePhone;
    dialogRef.componentInstance.isDialog = true;
  }
}
